export default __webpack_public_path__ + "static/giotto-plus-2-edfd5c7fff6103564c9a10db9313f364.jpg";